import LockIcon from '../../images/Lock-Icon.svg';
import UnlockIcon from '../../images/Unlock-Icon.svg';
import "../../css/templateForm.scss";

const LockTemplate = (props) => {
    const { closeLockModal, proceedLock, lockCardData } = props;
    return (
        <div>
            <div style={{padding: "15px 16px"}}>
                <div className='d-flex align-center lock-card-header'>
                    {lockCardData?.locked ? <img src={UnlockIcon} alt="" height={16} /> : <img src={LockIcon} alt="" height={16} />}
                    <h2>{lockCardData?.locked ? "Unlock" : "Lock"} Template</h2>
                </div>
                <div className='lock-card-messages'>
                    <h2>
                        <span className='lock-message'>{lockCardData?.locked 
                            ? "Unlocking the template will allow other users to edit it." 
                            : "Locking the template will prevent other users from editing it."}</span>
                        <span className='lock-confirmed-message'> Are you sure?</span>
                    </h2>
                </div>
                <div className='d-flex justify-content-between lock-card-buttons' style={{marginTop: "44px"}}>
                    <button className='cancel-lock-card' onClick={closeLockModal}>CANCEL</button>
                    <button className='proceed-lock-card' onClick={proceedLock}>PROCEED</button>
                </div>
            </div>
        </div>
    )
}

export default LockTemplate;